import { render, staticRenderFns } from "./TabletBlockForm.vue?vue&type=template&id=e0bc7a40&scoped=true"
import script from "./TabletBlockForm.vue?vue&type=script&lang=js"
export * from "./TabletBlockForm.vue?vue&type=script&lang=js"
import style0 from "./TabletBlockForm.vue?vue&type=style&index=0&id=e0bc7a40&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0bc7a40",
  null
  
)

export default component.exports